export default __webpack_public_path__ + "DGR_logo_primaer.png";